'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



//////////////////
// WEBPACK FOOTER
// ../es-errors/range.js
// module id = 521
// module chunks = 0